import { orchestrator } from 'satcheljs';
import { getMRUSuggestionsAction, storeMRUSuggestionsAction } from '../actions/internalActions';
import fetchMRUSuggestions from '../services/fetchMRUSuggestions';

export default orchestrator(getMRUSuggestionsAction, async function () {
    // getting MRU attachments, passing referenceItemId as null
    const mruSuggestions = await fetchMRUSuggestions(null /* referenceItemId */);

    if (mruSuggestions.suggestions) {
        storeMRUSuggestionsAction(mruSuggestions.suggestions, mruSuggestions.traceId);
    }
});
